<template>
  <div class="py-8 md:bg-putty md:py-20">
    <div class="flex flex-wrap items-center md:flex-nowrap container">
      <div
        class="flex flex-col justify-center w-full text-center relative shrink-0 md:text-left md:pr-4 md:max-w-xs lg:max-w-sm 2xl:max-w-lg"
      >
        <div class="w-full h-4 bg-gray-200 rounded mb-2"></div>
        <div class="h-8 bg-gray-200 rounded my-4"></div>
        <div class="h-4 bg-gray-200 rounded mb-4"></div>
      </div>
      <div
        class="w-full mt-6 md:mt-0 md:w-auto grid grid-cols-2 md:grid-cols-3 gap-x-10 md:gap-x-4 lg:gap-x-16 xl:gap-x-24 mx-auto"
      >
        <!-- First 2 products: always visible -->
        <div class="w-full h-32 sm:h-40 md:w-[200px] md:h-[200px] bg-gray-200 rounded"></div>
        <div class="w-full h-32 sm:h-40 md:w-[200px] md:h-[200px] bg-gray-200 rounded"></div>
        <!-- Third product: hidden on mobile, visible on md+ screens -->
        <div class="hidden md:block w-[200px] h-[200px] bg-gray-200 rounded"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineNuxtComponent({
  name: 'SkeletonLoading',
});
</script>
